import React from 'react';
import { Form, useField } from 'formik';
import { Signature_ApplicationFragment } from '../../generated.graphql';
import { TextFieldGroup } from 'shared/formik/TextFieldGroup';

interface Props {
  application: Signature_ApplicationFragment;
}

interface SignatureInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  signature: string;
}

const SignatureInput = ({ signature, ...props }: SignatureInputProps) => {
  const [field, /* meta */, helpers] = useField(props);
  return (
    <TextFieldGroup
      name={props.name}
      onChange={e => {
        const value = e.target.value.trim().toLocaleUpperCase();
        helpers.setValue(value);
        helpers.setError(signature.startsWith(value) ? '' : 'Signature does not match');
        helpers.setTouched(true, false);
      }}
      valid={field.value === signature}
    />
  );
};

export const DigitalSignature = ({ application }: Props) => {
  if (!application.digitalSignatureRequired) {
    return null;
  }

  return (
    <>
      <Form noValidate>
        <div className="my-4">
          <div className="row">
            <div className="col-12">
              <label htmlFor="digitalSignature">This code will act as your digital signature</label>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  name="digitalSignature"
                  readOnly={true}
                  disabled={true}
                  value={application.digitalSignature} 
                />
              </div>
            </div>
            <div className="col-12">
              <label htmlFor="digitalSignatureConfirmation">Please enter the code here as your digital signature</label>
            </div>
            <div className="col-md-6">
              <SignatureInput name="signature" signature={application.digitalSignature.trim().toLocaleUpperCase()} />
            </div>
          </div>
        </div>
      </Form>

      <p>This code has been generated to identify you in connection with the application being submitted. Please record this as it will also appear in any "signature box" in your copy of the rental agreement that you will receive by email on your application being approved. Should there be any discrepancy, please contact us immediately.</p>
    </>
  );
}